import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { User, LogOut, Plus, Home, BookOpen, HelpCircle, Sun, Moon } from 'lucide-react';
import Notifications from './Notifications';
import SettingsMenu from './SettingsMenu';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-sm border-b dark:border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-12">
          <Link to="/" className="flex items-center space-x-2 text-lg font-bold text-primary-600 dark:text-primary-400">
            <Home className="h-5 w-5" />
            <span>UniFAQ</span>
          </Link>

          <div className="flex items-center space-x-4">
            {user ? (
              <>
                <Link 
                  to="/dashboard" 
                  className="flex items-center space-x-1 text-sm text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  <HelpCircle className="h-3 w-3" />
                  <span>Мои FAQ</span>
                </Link>
                
                <Link 
                  to="/manual" 
                  className="flex items-center space-x-1 text-sm text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  <BookOpen className="h-3 w-3" />
                  <span>Мои Manual</span>
                </Link>
                
                <button
                  onClick={toggleTheme}
                  className="p-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  title={isDark ? 'Переключить на светлую тему' : 'Переключить на темную тему'}
                >
                  {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                </button>
                
                <Notifications />
                
                <SettingsMenu />
                
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-1 text-sm text-gray-700 dark:text-gray-300 hover:text-red-600 transition-colors"
                >
                  <LogOut className="h-3 w-3" />
                  <span>Выйти</span>
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={toggleTheme}
                  className="p-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  title={isDark ? 'Переключить на светлую тему' : 'Переключить на темную тему'}
                >
                  {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                </button>
                
                <Link 
                  to="/login" 
                  className="text-sm text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  Войти
                </Link>
                <Link 
                  to="/register" 
                  className="bg-primary-600 text-white px-3 py-1.5 rounded-md hover:bg-primary-700 transition-colors text-sm"
                >
                  Регистрация
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
